import React, {Suspense} from 'react'
import {BrowserRouter} from 'react-router-dom'
import {ApolloClient, InMemoryCache, ApolloProvider, HttpLink} from '@apollo/client'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import AuthInit from './modules/auth/redux/AuthInit'
import {Routes} from './routing/Routes'
import { setContext } from '@apollo/client/link/context';
import { onError } from "@apollo/client/link/error";
import AuthService from '../app/modules/auth/redux/AuthService'
import { API_URL } from "../setup";

type Props = {
  basename: string
}

const App: React.FC<Props> = ({basename}) => {

  


const user = AuthService.GetCurrentUser() != null ? AuthService.GetCurrentUser() : null;

const httpLink = new HttpLink({
  uri: API_URL.concat('/graphql/'),
});



const authLink = setContext((_, { headers }) => {
  const token = user != null ? user.token : ''
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  }
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    //strinify
    graphQLErrors.forEach(({ message, path }) => {
      if (/not authorized/.test(message)) {
        localStorage.clear();
        document.location.reload()
      }
    });
  }
});

 const client = new ApolloClient({
  link: errorLink.concat(authLink.concat(httpLink)),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    }
  },
  cache: new InMemoryCache(),
});





  return (
    <ApolloProvider client={client}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <BrowserRouter basename={basename}>
          <I18nProvider>
            <LayoutProvider>
              <AuthInit>
                <Routes />
              </AuthInit>
            </LayoutProvider>
          </I18nProvider>
        </BrowserRouter>
      </Suspense>
    </ApolloProvider>
  )
}

export {App}
